
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.MAGAZINE_EMOJIS_SHOW,
  closeType: actions.MAGAZINE_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/emojis/magazineContribute/reducer.js
 **/